import { useAppState } from "../../../Stores/AppState";

export function closeWorklineFilterPanel() {
    const app_state_store = useAppState();
    if (!app_state_store.worklineFilterDrawer) return;
    app_state_store.worklineFilterDrawer = false;
}
